import { combineReducers } from 'redux'
import userContextReducer from './userContextReducer'
import layoutReducer from './layoutReducer'
import navbarReducer from './navbarReducer'
import chatbotReducer from './chatbotReducer'

const rootReducer = combineReducers({
  layoutReducer,
  navbarReducer,
  userContextReducer,
  chatbotReducer
})

export default rootReducer
